export function createIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateStoredIdempotencyKey(storageKey: string): string {
  const next = () => createIdempotencyKey();
  try {
    const existing = localStorage.getItem(storageKey);
    if (existing) return existing;
    const created = next();
    localStorage.setItem(storageKey, created);
    return created;
  } catch {
    return next();
  }
}

export function clearStoredIdempotencyKey(storageKey: string) {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    // Ignore storage failures; idempotency still works for the current request.
  }
}
